// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PagoCupones_container__YMN8k {
  animation: PagoCupones_init__xLhp8 1s;
  display: flex;
  align-items: flex-start;
  justify-content: center;
}

/*--Header--*/
.PagoCupones_container__YMN8k .PagoCupones_header__OsuS\\+ {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.PagoCupones_container__YMN8k .PagoCupones_header__OsuS\\+ .PagoCupones_titleContainer__jQHLK {
  animation: PagoCupones_init3__CenJ2 0.3s both 0.5s;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.PagoCupones_container__YMN8k .PagoCupones_header__OsuS\\+ .PagoCupones_titleContainer__jQHLK h4 {
  text-align: center;
  font-size: 1.6rem;
  font-family: Roboto, sans-serif;
  font-weight: 300;
  margin-left: 10px;
}

.PagoCupones_container__YMN8k .PagoCupones_header__OsuS\\+ .PagoCupones_titleContainer__jQHLK .PagoCupones_add_btn__JitNI {
  transition: 0.3s;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 2.5rem;
  width: 6.5rem;
  border-radius: 5px;
  font-size: 1rem;
  font-weight: 300;
  text-transform: capitalize;
  font-family: Roboto, sans-serif;
  margin-left: 10px;
}

.PagoCupones_container__YMN8k .PagoCupones_filters__RkWnZ {
  animation: PagoCupones_init2__SM9r0 0.3s both 0.5s;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.PagoCupones_container__YMN8k .PagoCupones_filters__RkWnZ .PagoCupones_filterButton__U7\\+oE {
  text-transform: capitalize;
  height: 3rem;
  width: 10rem;
  margin-bottom: 10px;
  border-radius: 5px;
}

.PagoCupones_container__YMN8k .PagoCupones_header__OsuS\\+ .PagoCupones_filters__RkWnZ .PagoCupones_filterButton__U7\\+oE p {
  font-size: 0.9rem;
  margin-left: 5px;
  font-weight: 400;
}

.PagoCupones_container__YMN8k .PagoCupones_noResults__67Z-s {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 1.5rem;
  font-weight: 300;
  height: 300px;
}

/*---Información---*/
.PagoCupones_container__YMN8k .PagoCupones_data__A5NMG .PagoCupones_tableContainer__wPurX {
  animation: PagoCupones_init2__SM9r0 0.3s both 0.3s;
  border-radius: 10px;
  max-height: 80vh;
  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);
}

.PagoCupones_container__YMN8k .PagoCupones_data__A5NMG .PagoCupones_tableContainer__wPurX .PagoCupones_iconbtn__uo-Nx {
  transition: 0.3s;
  font-size: 1.8rem;
}

.PagoCupones_container__YMN8k .PagoCupones_data__A5NMG .PagoCupones_tableContainer__wPurX .PagoCupones_iconbtn__uo-Nx:hover {
  transition: 0.3s;
  cursor: pointer;
  filter: brightness(0.7);
  scale: 1.1;
}

.PagoCupones_container__YMN8k .PagoCupones_loader__K2G\\+g {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 300px;
}

@keyframes PagoCupones_init__xLhp8 {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes PagoCupones_init2__SM9r0 {
  0% {
    opacity: 0;
    transform: translateX(20px);
  }
  100% {
    opacity: 1;
    transform: translateX(0px);
  }
}

@keyframes PagoCupones_init3__CenJ2 {
  0% {
    opacity: 0;
    transform: translateX(-20px);
  }
  100% {
    opacity: 1;
    transform: translateX(0px);
  }
}

@media screen and (max-width: 500px) {
  .PagoCupones_container__YMN8k .PagoCupones_header__OsuS\\+ .PagoCupones_titleContainer__jQHLK .PagoCupones_add_btn__JitNI {
    width: 80px;
    height: 40px;
  }
  .PagoCupones_container__YMN8k .PagoCupones_header__OsuS\\+ .PagoCupones_titleContainer__jQHLK h4 {
    font-size: 1.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Pages/Pagos/PagoCupones.module.css"],"names":[],"mappings":"AAAA;EACE,qCAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,kDAA+B;EAC/B,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,kDAA+B;EAC/B,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;AACf;;AAEA,oBAAoB;AACpB;EACE,kDAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".container {\n  animation: init 1s;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n}\n\n/*--Header--*/\n.container .header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.container .header .titleContainer {\n  animation: init3 0.3s both 0.5s;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.container .header .titleContainer h4 {\n  text-align: center;\n  font-size: 1.6rem;\n  font-family: Roboto, sans-serif;\n  font-weight: 300;\n  margin-left: 10px;\n}\n\n.container .header .titleContainer .add_btn {\n  transition: 0.3s;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 2.5rem;\n  width: 6.5rem;\n  border-radius: 5px;\n  font-size: 1rem;\n  font-weight: 300;\n  text-transform: capitalize;\n  font-family: Roboto, sans-serif;\n  margin-left: 10px;\n}\n\n.container .filters {\n  animation: init2 0.3s both 0.5s;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n}\n\n.container .filters .filterButton {\n  text-transform: capitalize;\n  height: 3rem;\n  width: 10rem;\n  margin-bottom: 10px;\n  border-radius: 5px;\n}\n\n.container .header .filters .filterButton p {\n  font-size: 0.9rem;\n  margin-left: 5px;\n  font-weight: 400;\n}\n\n.container .noResults {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  font-size: 1.5rem;\n  font-weight: 300;\n  height: 300px;\n}\n\n/*---Información---*/\n.container .data .tableContainer {\n  animation: init2 0.3s both 0.3s;\n  border-radius: 10px;\n  max-height: 80vh;\n  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);\n}\n\n.container .data .tableContainer .iconbtn {\n  transition: 0.3s;\n  font-size: 1.8rem;\n}\n\n.container .data .tableContainer .iconbtn:hover {\n  transition: 0.3s;\n  cursor: pointer;\n  filter: brightness(0.7);\n  scale: 1.1;\n}\n\n.container .loader {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 300px;\n}\n\n@keyframes init {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n@keyframes init2 {\n  0% {\n    opacity: 0;\n    transform: translateX(20px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateX(0px);\n  }\n}\n\n@keyframes init3 {\n  0% {\n    opacity: 0;\n    transform: translateX(-20px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateX(0px);\n  }\n}\n\n@media screen and (max-width: 500px) {\n  .container .header .titleContainer .add_btn {\n    width: 80px;\n    height: 40px;\n  }\n  .container .header .titleContainer h4 {\n    font-size: 1.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `PagoCupones_container__YMN8k`,
	"init": `PagoCupones_init__xLhp8`,
	"header": `PagoCupones_header__OsuS+`,
	"titleContainer": `PagoCupones_titleContainer__jQHLK`,
	"init3": `PagoCupones_init3__CenJ2`,
	"add_btn": `PagoCupones_add_btn__JitNI`,
	"filters": `PagoCupones_filters__RkWnZ`,
	"init2": `PagoCupones_init2__SM9r0`,
	"filterButton": `PagoCupones_filterButton__U7+oE`,
	"noResults": `PagoCupones_noResults__67Z-s`,
	"data": `PagoCupones_data__A5NMG`,
	"tableContainer": `PagoCupones_tableContainer__wPurX`,
	"iconbtn": `PagoCupones_iconbtn__uo-Nx`,
	"loader": `PagoCupones_loader__K2G+g`
};
export default ___CSS_LOADER_EXPORT___;
